import { getCatalogue } from './catalogueClient';

export const getYears = async (brandId, modelId, options) => {
  if (!brandId || !modelId) return [];
  return getCatalogue('years', [brandId, modelId], 'getYearsV2', { brandId, modelId }, options);
};
